export default __webpack_public_path__ + "static/media/regulatory--one-way-left--g3.0113405a.png";